
import { Base } from '../../../base/components/base'
import { Div } from '../../../base/components/native/div'
import { HIDE, SHOW } from '../../../base/helpers/style'
import router from '../../../base/lib/router'
import {emitter} from '../../../base/utils/emitter'
import authService from '../../../services/auth-service'
import { PAGE_ENTER_DEFAULT_STYLE, PAGE_EXIT_DEFAULT_STYLE, PAGE_STYLE } from '../page'
import { GoogleButton } from './google-button'
import { LoginForm } from './login-form'
// Todo: refactor the page
export const LoginPage = () => {
    const base = Base()


    const contents = Div().cssClass({ padding: '40px' })
    const message = Div('برای ادامه استفاده از برنامه، لطفا وارد شوید.')
    message.cssClass(HIDE)
    const google = GoogleButton()
    const logout = Div('خروج').cssClass({ display: 'none' })
    const form = LoginForm()
    base.append(contents)
    contents.append(message, google, logout, form)

    google.on('request-login', async () => {
        await authService.googleLogin()
    })
    form.on('request-login', async (data: any) => {
        await authService.emailLogin(data)

    })
    emitter.on('loggedin-failed', () => {
        google.enable()
        form.failed()
        message.cssClass(SHOW)
        message.text('ورود ناموفق')
    })
    emitter.on('loggedin', () => {
        google.enable()
        form.done()
        router.goto('/')
        message.cssClass(HIDE)
        message.text('')
    })
    emitter.on('wrong-role', () => {
        google.enable()
        form.done()
        message.cssClass(SHOW)
        message.text('شما اجازه دسترسی به برنامه را ندارید')
    })




    message.cssClass({
        marginBottom: '20px'
    })
    base.cssClass(PAGE_STYLE)
    base.style({ backgroundColor: 'white' })
    return Object.assign(base, {
        enter() {
            console.log('in login enter');

            base.style(PAGE_ENTER_DEFAULT_STYLE)
        },
        exit() {
            base.style(PAGE_EXIT_DEFAULT_STYLE)
        }
    })
}